import { createSelector } from 'reselect';

import { salesTaxesSelectors as stdSliceSelectors } from './salesTaxesSlice';
export { stdSliceSelectors };

// this can be used to validate sales tax names are unique
export const uniqueLowercaseItemNames = createSelector(stdSliceSelectors.selectAll, (salesTaxes) => {
  return salesTaxes.reduce((lookup, salesTax) => {
    if (salesTax.name) {
      lookup.add(salesTax.name.toLowerCase());
    }
    return lookup;
  }, new Set<string>());
});
